import moment                                          from "moment";
import React, { FC, useState }                         from "react";
import { useDispatch, useSelector }                    from "react-redux";
import { Button, Checkbox, Icon, Input, Modal, Table } from "semantic-ui-react";
import GetCustomersHaveEmail
                                                       from "../../../application/usecase/customer/GetCustomersHaveEmail";
import CustomerSearchValue                             from "../../../domain/customer/criteria/CustomerSearchValue";
import Customer                                        from "../../../domain/customer/Customer";
import CustomerBirthDate                               from "../../../domain/customer/CustomerBirthDate";
import CustomerBirthday                                from "../../../domain/customer/CustomerBirthday";
import CustomerBirthMonth                              from "../../../domain/customer/CustomerBirthMonth";
import CustomerBirthYear                               from "../../../domain/customer/CustomerBirthYear";
import CustomerContact                                 from "../../../domain/customer/CustomerContact";
import CustomerDetail                                  from "../../../domain/customer/CustomerDetail";
import CustomerId                                      from "../../../domain/customer/CustomerId";
import CustomerNumber                                  from "../../../domain/customer/CustomerNumber";
import CustomerRepository                              from "../../../domain/customer/CustomerRepository";
import Customers                                       from "../../../domain/customer/Customers";
import Address                                         from "../../../domain/fundamentals/address/Address";
import Building                                        from "../../../domain/fundamentals/address/Building";
import City                                            from "../../../domain/fundamentals/address/City";
import PostalCode                                      from "../../../domain/fundamentals/address/PostalCode";
import Prefecture                                      from "../../../domain/fundamentals/address/Prefecture";
import Street                                          from "../../../domain/fundamentals/address/Street";
import Email                                           from "../../../domain/fundamentals/email/Email";
import FirstName                                       from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana                                   from "../../../domain/fundamentals/name/FirstNameKana";
import LastName                                        from "../../../domain/fundamentals/name/LastName";
import LastNameKana                                    from "../../../domain/fundamentals/name/LastNameKana";
import Name                                            from "../../../domain/fundamentals/name/Name";
import CurrentPage                                     from "../../../domain/fundamentals/pagination/CurrentPage";
import Phone                                           from "../../../domain/fundamentals/phone/Phone";
import CreatedAt                                       from "../../../domain/fundamentals/trail/CreatedAt";
import Trail                                           from "../../../domain/fundamentals/trail/Trail";
import UpdatedAt                                       from "../../../domain/fundamentals/trail/UpdatedAt";
import MailSendRepository                              from "../../../domain/mail/send/MailSendRepository";
import { ResKaState }                                  from "../../../index";
import CustomerDataSource
                                                       from "../../../infrastructure/datasource/customer/CustomerDataSource";
import MailSendDataSource
                                                       from "../../../infrastructure/datasource/mail/send/MailSendDataSource";
import BottomSection                                   from "../common/layout/BottomSection";
import ListTotalCount                                  from "../common/layout/ListTotalCount";
import TopSection                                      from "../common/layout/TopSection";
import ListPagination                                  from "../common/ListPagination";

const MailSendDestinationCustomerSelector: FC = () => {
  const [open, setOpen] = useState(false);
  const [selectedCustomers, setCustomers] = useState(new Customers());
  const customers: Customers = useSelector((state: ResKaState) => state.customers);
  const repository: MailSendRepository = new MailSendDataSource(useDispatch());
  const customerRepository: CustomerRepository = new CustomerDataSource(useDispatch());
  const getCustomersHaveEmail: GetCustomersHaveEmail = new GetCustomersHaveEmail(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        onClick={ () => {
          getCustomersHaveEmail.execute(new CurrentPage(), new CustomerSearchValue());
          setCustomers(new Customers());
          setOpen(true);
        } }
      >
        <Icon name="address book"/>
        送信先を選択する
      </Button>

      <Modal
        open={ open }
      >
        <Modal.Header>送信先の選択</Modal.Header>

        <Modal.Content>
          <TopSection>
            <Input
              icon="search"
              placeholder="顧客検索"
              defaultValue={ customers.search.value }
              onChange={ (event, data) => setTimeout(() => getCustomersHaveEmail.execute(customers.pagination.current, new CustomerSearchValue(data.value)), 500) }
            />
          </TopSection>

          <TopSection>
            <Button
              onClick={ () => {
                customerRepository.findAllHaveEmail(customers.search).then(response => {
                  const list: Customer[] = response.data.customers.map(customer => new Customer(
                    new CustomerId(customer.id),
                    new CustomerDetail(
                      new CustomerNumber(customer.detail.number),
                      new Name(
                        new LastName(customer.detail.last_name),
                        new FirstName(customer.detail.first_name),
                        new LastNameKana(customer.detail.last_name_kana),
                        new FirstNameKana(customer.detail.first_name_kana),
                      ),
                      customer.detail.gender_type,
                    ),
                    new CustomerBirthday(
                      new CustomerBirthYear(customer.birthday.year),
                      new CustomerBirthMonth(customer.birthday.month),
                      new CustomerBirthDate(customer.birthday.date),
                    ),
                    new CustomerContact(
                      new Phone(customer.contact.phone_number),
                      new Email(customer.contact.email),
                    ),
                    new Address(
                      new PostalCode(customer.address.postal_code),
                      new Prefecture(customer.address.prefecture),
                      new City(customer.address.city),
                      new Street(customer.address.street),
                      new Building(customer.address.building)
                    ),
                    new Trail(
                      new CreatedAt(moment(customer.trail.created_at)),
                      new UpdatedAt(moment(customer.trail.updated_at))
                    )
                  ));
                  setCustomers(new Customers(list));
                })
              } }
            >
              全選択
            </Button>
            <Button
              onClick={ () => setCustomers(new Customers()) }
            >
              全解除
            </Button>
          </TopSection>
          {
            customers.isEmpty()
              ?
              <p>顧客情報がありません。</p>
              :
              <>
                <ListTotalCount>{ customers.count.toString() }</ListTotalCount>
                <Table
                  striped
                  selectable
                >
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>選択</Table.HeaderCell>
                      <Table.HeaderCell>顧客番号</Table.HeaderCell>
                      <Table.HeaderCell>顧客氏名</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {
                      customers.toList().map(customer => (
                        <Table.Row
                          onClick={ () => selectedCustomers.has(customer.id) ? setCustomers(selectedCustomers.remove(customer)) : setCustomers(selectedCustomers.add(customer)) }
                        >
                          <Table.Cell>
                            <Checkbox
                              checked={ selectedCustomers.has(customer.id) }
                              onClick={ () => selectedCustomers.has(customer.id) ? setCustomers(selectedCustomers.remove(customer)) : setCustomers(selectedCustomers.add(customer)) }
                            />
                          </Table.Cell>
                          <Table.Cell>{ customer.detail.number.value }</Table.Cell>
                          <Table.Cell>{ `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }` }</Table.Cell>
                        </Table.Row>
                      ))
                    }
                  </Table.Body>
                </Table>

                <BottomSection>
                  <ListPagination
                    currentPage={ customers.pagination.current }
                    totalPage={ customers.pagination.total }
                    onChangePage={ currentPage => getCustomersHaveEmail.execute(currentPage, customers.search) }
                  />
                </BottomSection>
              </>
          }
        </Modal.Content>

        <Modal.Actions>
          <Button
            icon
            labelPosition="left"
            disabled={ selectedCustomers.isEmpty() }
            positive={ !selectedCustomers.isEmpty() }
            onClick={ () => {
              repository.setMailSendCustomers(selectedCustomers);
              setOpen(false);
            } }
          >
            <Icon name="check"/>
            決定する
          </Button>

          <Button
            onClick={ () => setOpen(false) }
          >
            閉じる
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
};

export default MailSendDestinationCustomerSelector;
